import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f96f2ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-boom-wrap" }
const _hoisted_2 = { class: "nongfu-checkbox-wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "请选择是否炸机", -1))

import { Checkbox } from 'vant'
import { ref, withDefaults, watch } from 'vue'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair/index'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'select-boom',
  props: {
    show: { type: Boolean, default: false }
  },
  emits: ['confirm'],
  setup(__props: any, { emit: emits }) {

const props = __props as { show: boolean };



const { malfunctionRepairState, changeBoomValue } = useMalfunctionRepairStore()
const boomValue = ref(undefined)

watch(
  () => props.show,
  () => {
    boomValue.value = malfunctionRepairState.isBoom
  },
  { immediate: true }
)
function clickHandle(bool: boolean) {
  boomValue.value = bool
}
function confirmHandle() {
  changeBoomValue(boomValue.value)
  emits('confirm')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "checkbox-wrap",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (clickHandle(true)))
      }, [
        _createVNode(_unref(Checkbox), {
          "icon-size": "20px",
          class: "checkbox-item",
          modelValue: boomValue.value === true
        }, null, 8, ["modelValue"]),
        _createTextVNode(" 炸机 ")
      ]),
      _createElementVNode("div", {
        class: "checkbox-wrap",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (clickHandle(false)))
      }, [
        _createVNode(_unref(Checkbox), {
          "icon-size": "20px",
          class: "checkbox-item",
          modelValue: boomValue.value === false
        }, null, 8, ["modelValue"]),
        _createTextVNode(" 非炸机 ")
      ]),
      _createVNode(CommonFooterNextButton, {
        title: "确定",
        disabled: boomValue.value === undefined,
        class: "footer-item",
        onClick: confirmHandle
      }, null, 8, ["disabled"])
    ])
  ]))
}
}

})